module.exports = __webpack_public_path__ + "img/icon(9).01ef6747.png";